// Copyright 2026, Auxilio Technologies LLC

import {
  HomeIcon,
  ClipboardDocumentListIcon,
  PlusCircleIcon,
  SparklesIcon,
  MapIcon,
  TruckIcon,
  UsersIcon,
  Cog6ToothIcon,
} from '@heroicons/react/24/outline';
import { Permissions, PermissionType } from './rolesConfig';

export interface NavItem {
  nameKey: string; // i18n key under nav.*
  path: string;
  icon: React.ComponentType<{ className?: string }>;
  permission?: PermissionType;
}

export interface NavCategory {
  nameKey: string; // i18n key under nav.*
  items: NavItem[];
}

export const navigationConfig: NavCategory[] = [
  {
    nameKey: 'nav.overview',
    items: [{ nameKey: 'nav.dashboard', path: '/dashboard', icon: HomeIcon, permission: Permissions.DASHBOARD_READ }],
  },
  {
    nameKey: 'nav.orders',
    items: [
      { nameKey: 'nav.orderBoard', path: '/orders', icon: ClipboardDocumentListIcon, permission: Permissions.ORDERS_READ },
      { nameKey: 'nav.addOrder', path: '/orders/new', icon: PlusCircleIcon, permission: Permissions.ORDERS_WRITE },
    ],
  },
  {
    nameKey: 'nav.prep',
    items: [{ nameKey: 'nav.prepQueue', path: '/prep', icon: SparklesIcon, permission: Permissions.PREP_READ }],
  },
  {
    nameKey: 'nav.dispatch',
    items: [{ nameKey: 'nav.routeBuilder', path: '/routes', icon: MapIcon, permission: Permissions.DISPATCH_READ }],
  },
  {
    nameKey: 'nav.delivery',
    items: [{ nameKey: 'nav.driverView', path: '/driver', icon: TruckIcon, permission: Permissions.DRIVER_READ }],
  },
  {
    nameKey: 'nav.administration',
    items: [
      { nameKey: 'nav.users', path: '/admin/users', icon: UsersIcon, permission: Permissions.USERS_READ },
      { nameKey: 'nav.settings', path: '/settings', icon: Cog6ToothIcon, permission: Permissions.SETTINGS_READ },
    ],
  },
];

// Map nav path -> permission, used to guard routes.
export const NavPermissionMap: Record<string, PermissionType> = {
  '/dashboard': Permissions.DASHBOARD_READ,
  '/orders': Permissions.ORDERS_READ,
  '/orders/new': Permissions.ORDERS_WRITE,
  '/prep': Permissions.PREP_READ,
  '/routes': Permissions.DISPATCH_READ,
  '/driver': Permissions.DRIVER_READ,
  '/admin/users': Permissions.USERS_READ,
  '/settings': Permissions.SETTINGS_READ,
};
